export default "__VITE_ASSET__DkYEhXJb__"